import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  // Link
} from 'react-router-dom'

import Home from './pages/home';


export const routes = [
  {
    path: '/',
    label: 'Home',
    component: Home,
    title: 'Difficult Decision, Easy Choice',
  },

]


const DefaultLayout = ({component: Component, ...rest}) => {
  return (
    <Route {...rest} render={matchProps => (
        <Component {...matchProps} />
    )} />
  )
};

const App = () => (
  <Router>
    <div>
      {routes.map(route=>{
        return (
          <DefaultLayout exact key={route.path} {...route}/>
        )
      })}
    </div>
  </Router>
)
export default App


// WEBPACK FOOTER //
// ./src/App.js